import React, { useState } from "react";

const TimeSegmentButtons = ({ onSegmentChange }) => {
  const [activeSegment, setActiveSegment] = useState("today");

  const segments = [
    { label: "Today", value: "today" },
    { label: "This Week", value: "thisWeek" },
    { label: "Last Week", value: "lastWeek" },
  ];

  const handleSegmentClick = (value) => {
    setActiveSegment(value);
    onSegmentChange?.(value); // Call parent function if provided
  };

  return (
    <div className="flex border border-blue-600 rounded-lg overflow-hidden">
      {segments.map(({ label, value }) => (
        <button
          key={value}
          className={`px-4 py-2 text-sm font-medium transition-colors duration-200 flex-1 text-center 
            ${
              activeSegment === value
                ? "bg-custom-blue text-white"
                : "bg-white text-custom-blue hover:bg-blue-50"
            }`}
          onClick={() => handleSegmentClick(value)}
          aria-pressed={activeSegment === value}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default TimeSegmentButtons;
